import { makeStyles } from "@mui/styles"

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem 0',
    '& > p': {
      maxWidth: '50%',
    },
  },
}))

export default styles
